export default {
  __html: `<g fill="#currentColor" fill-rule="evenodd">
              <circle cx="12" cy="12" r="12" fill="#D7DD1A"/>
              <path stroke="#2A2264" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9l-6.483 6L8 12.67"/>
            </g>`
}



// WEBPACK FOOTER //
// ./src/app/elements/Icon/checkGreen.js